import React, { useState, useEffect } from "react";
import {
  getPropertyImages,
  uploadPropertyImage,
  deletePropertyImage,
} from "../../utils/api";

function PropertyImagesModal({
  show,
  onClose,
  propertyId,
  refresh,
  setBanner,
}) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (propertyId && show) {
      setLoading(true);
      getPropertyImages(propertyId)
        .then((res) => {
          // ✅ Use res.images instead of res
          setImages(res?.images || []);
        })
        .catch(() =>
          setBanner({
            type: "danger",
            message: "Failed to load property images.",
          })
        )
        .finally(() => setLoading(false));
    }
  }, [propertyId, show, setBanner]);

  if (!show) return null;

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Restrict to image files only
    if (!file.type.startsWith("image/")) {
      setBanner({ type: "danger", message: "Only image files are allowed." });
      return;
    }

    const fd = new FormData();
    fd.append("property_id", propertyId);
    fd.append("image", file);

    uploadPropertyImage(fd)
      .then(() => {
        setBanner({ type: "success", message: "Image uploaded successfully!" });
        return getPropertyImages(propertyId).then((res) =>
          setImages(res?.images || [])
        );
      })
      .catch(() => setBanner({ type: "danger", message: "Upload failed." }))
      .finally(refresh);
  };

  const handleDelete = (id) => {
    deletePropertyImage(id)
      .then(() => {
        setBanner({ type: "warning", message: "Image deleted successfully." });
        setImages((prev) => prev.filter((img) => img.id !== id));
      })
      .catch(() => setBanner({ type: "danger", message: "Delete failed." }))
      .finally(refresh);
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Manage Property Images</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {/* ✅ Restrict file picker to images */}
            <input
              type="file"
              accept="image/*"
              className="form-control mb-3"
              onChange={handleUpload}
            />

            {loading ? (
              <p className="text-muted text-center">Loading images...</p>
            ) : (
              <div className="row">
                {images.map((img) => (
                  <div
                    key={img.id}
                    className="col-sm-6 col-md-3 mb-3 text-center"
                  >
                    {img.src ? (
                      <img
                        src={img.src}
                        alt={`Property view ${img.id}`}
                        className="property-image img-fluid"
                      />
                    ) : (
                      <div className="bg-light text-muted p-5">No Image</div>
                    )}
                    <button
                      className="btn btn-sm btn-danger mt-2"
                      onClick={() => handleDelete(img.id)}
                    >
                      Delete
                    </button>
                  </div>
                ))}
                {images.length === 0 && (
                  <p className="text-muted text-center">
                    No images uploaded yet.
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyImagesModal;
